export function anchorCareers() {
    $('.careers-title .btn').on('click', function (e) {
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
        e.preventDefault();
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/anchorCareers.js